export default "__VITE_ASSET__f6598e08__"